import {TRouteId} from "../index";

export const EntityTypes = [
    'CompanyEntity',
    'CompanySyncStepEntity',
    'CompanySyncStepRuleSetEntity',
    'ExportFlowEntity',
    'ExportTemplateEntity',
    'FormTemplateEntity',
    'FormTemplatePageEntity',
    'ManualObjectEntity',
    'MessageEntity',
    'ObjectAnchorEntity',
    'ObjectEntity',
    'ObjectExportTemplateEntity',
    'ObjectPermissionEntity',
    'RuleEntity',
    'RuleSetEntity',
    'SyncFieldDisplayNameEntity',
    'SyncFieldEntity',
    'SyncStepHistoryEntity',
    'SystemEntity',
    'SystemRoleEntity',
] as const;

export type _TEntityType = typeof EntityTypes[number];

export const Entity2RouteId: Record<_TEntityType, TRouteId | null> = {
    'CompanyEntity': 'customerconfig',
    'CompanySyncStepEntity': 'syncstatusv2',
    'CompanySyncStepRuleSetEntity': 'rulesetdetails',
    'ExportFlowEntity': null, // 'synctemplatedetails', // parent object
    'ExportTemplateEntity': 'synctemplatedetails',
    'FormTemplateEntity': 'formtemplatedetails',
    'FormTemplatePageEntity': null, // 'formtemplatedetails', // parent object
    'ManualObjectEntity': null,
    'MessageEntity': 'messageflowdetails',
    'ObjectAnchorEntity': null,
    'ObjectEntity': null,
    'ObjectExportTemplateEntity': null,
    'ObjectPermissionEntity': null, // 'userpermissions', // parent object
    'RuleEntity': null, // 'rulesetdetails', // parent object
    'RuleSetEntity': 'rulesetdetails',
    'SyncFieldDisplayNameEntity': 'systemfieldsdetails', // parent object,
    'SyncFieldEntity': 'systemfieldsdetails', // parent object,
    'SyncStepHistoryEntity': null, // 'importhistorydetails', // parent object,
    'SystemEntity': 'systemaccessdetails',
    'SystemRoleEntity': null, // 'systemaccessdetails', // parent object
} as const